import {useCallback, useMemo} from 'react';
import {judgeUrl, analysisDialogId, addParamsToUrl} from '@/utils/utils';
import {useDispatchStore, ACTIONS} from '@/pages/Store';
import {logClkReport} from '@/utils/ubcUtils';
import {navigate} from '@/utils/navigate';
import {customizeLogType} from '@/interfaces/specialDisease';
import {WHITE_LIST} from '@/dicts/networkWhiteList';
import useRouter from './router';

export interface logParams {
    page?: string;
    value?: string;
    channelId?: string;
    pageType?: string;
    moduleId?: number;
    moduleName?: string;
    customize?: customizeLogType;
}

interface urlParamsType {
    linkUrl?: string;
    swanUrl?: string;
}


export default function useHandleClick() {
    const dispatch = useDispatchStore();
    const router = useRouter();
    const addParams = useMemo(
        () => {
            const params: {[key: string]: string} = {};
            // eslint-disable-next-line array-callback-return
            Object.keys(router?.query).map(item => {
                WHITE_LIST.includes(item) && (params[item] = router?.query?.[item] as string || '');
            });
            return params;
        },
        [router?.query]
    );
    // eslint-disable-next-line camelcase
    const {from = '', sf_ref = '', sf_ch = ''} = router?.query || {};
    const navigateToUrl = useCallback(
        (urlParams: urlParamsType, logParams: logParams) => {
            const {
                linkUrl = '',
                swanUrl = '',
            } = urlParams;

            const {
                page = '',
                value = '',
                channelId = '',
                pageType = '',
                moduleId = 0,
                moduleName = '',
                customize = {
                    // eslint-disable-next-line camelcase
                    value_key: '',
                    // eslint-disable-next-line camelcase
                    value_type: '',
                    // eslint-disable-next-line camelcase
                    value_title: '',
                },
            } = logParams;

            const sendLogger = () => {
                logClkReport(
                    page,
                    value,
                    channelId,
                    pageType,
                    moduleId,
                    moduleName,
                    customize
                );
            };

            const dispatchModuleID = (url: string) => {
                analysisDialogId(url) && dispatch?.({
                    type: ACTIONS.SET_DIALOG_STATUS,
                    payload: analysisDialogId(url),
                });
            };

            const isBdBox = navigator.userAgent.includes('baiduboxapp');
            const jumpLink = isBdBox && swanUrl ? swanUrl : linkUrl;
            const newJumpLink = addParamsToUrl(jumpLink, {
                from: from,
                // eslint-disable-next-line camelcase
                sf_ref: sf_ref,
                // eslint-disable-next-line camelcase
                sf_ch: sf_ch,
                ...addParams,
            });
            if (judgeUrl(newJumpLink)) {
                navigate(newJumpLink);
            } else {
                dispatchModuleID(newJumpLink);
            }
            sendLogger();
        },
        // eslint-disable-next-line camelcase
        [dispatch, from, sf_ch, sf_ref, addParams]
    );
    return {
        navigateToUrl,
    };
}
